module.exports = __webpack_public_path__ + "img/orare.2ec39dfd.jpg";